/* required-options.js (11-2-26)
   Dawn's product form is novalidate, so a required select left on "Choose one"
   or an unchecked radio group would still add to cart (and Shopify drops the
   blank property). This blocks the add-to-cart in the capture phase until every
   [data-required-option] inside [data-required-options] has a value, mirroring
   the guard in cut-to-size.js. */
(function () {
  function formOf(wrap) {
    var el = wrap.querySelector('select[form], input[form]');
    return el && el.getAttribute('form') ? document.getElementById(el.getAttribute('form')) : wrap.closest('form');
  }
  function missing(wrap) {
    var fields = wrap.querySelectorAll('[data-required-option]');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (f.tagName === 'SELECT') { if (!f.value) return f; }
      else if (!f.querySelector('input[type="radio"]:checked')) return f;
    }
    return null;
  }
  function status(wrap, text, warn) {
    var s = wrap.querySelector('[data-required-status]');
    if (!s) return;
    s.textContent = text || '';
    s.hidden = !text;
    s.classList.toggle('perforated-options__status--warn', !!warn);
  }
  function guard(event) {
    var wraps = document.querySelectorAll('[data-required-options]');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i], form = formOf(wrap);
      if (!form) continue;
      var t = event.target;
      var ours = (event.type === 'submit' && t === form) ||
                 (event.type === 'click' && t.closest && t.closest('[type="submit"]') && t.closest('form') === form);
      if (!ours) continue;
      var f = missing(wrap);
      if (!f) { status(wrap, ''); continue; }
      event.preventDefault(); event.stopImmediatePropagation();
      var label = f.tagName === 'SELECT' ? (wrap.querySelector('label[for="' + f.id + '"]') || {}).textContent : (f.querySelector('legend') || {}).textContent;
      label = (label || '').replace('*', '').trim();
      status(wrap, (f.getAttribute('data-required-message') || 'Please choose an option.') + (label ? ' (' + label + ')' : ''), true);
      var focusEl = f.tagName === 'SELECT' ? f : f.querySelector('input');
      try { focusEl.reportValidity(); } catch (e) {}
      focusEl.focus();
      return;
    }
  }
  document.addEventListener('submit', guard, true);
  document.addEventListener('click', guard, true);
  document.addEventListener('change', function (e) {
    var wrap = e.target.closest && e.target.closest('[data-required-options]');
    if (wrap && !missing(wrap)) status(wrap, '');
  });
})();
